import { get } from '.';

export function GetTekionAppointmentUrl(options = {}) {
	return get<any>("/app/api/tekion/appointment_url", options);
}
